import styled, {css} from "styled-components";
import {motion} from "framer-motion";
import { CgChevronDoubleDown } from 'react-icons/cg'
import { IoMdRefresh } from 'react-icons/io';
import { AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai'
import {Flex} from "../MarketStyles";

export const DraggableItem = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  ${props => (props.item === 'market-change' || props.item === 'order-book') && css`
    overflow: visible;
  `};
  
  ${props => props.item === 'chart' && css`
    overflow: hidden;
  `};
`


export const LSWrapper = styled(motion.div)`
  position: fixed;
  top: 80px;
  z-index: 10000;
  direction: ${props => props.theme.english ? 'ltr': 'rtl'};
  ${props => props.theme.english && css`
    right: 0;
  `};
  ${props => !props.theme.english && css`
    left: 0;
  `};
`

export const LSBody = styled.div`
  width: 340px;
  padding: 10px 16px;
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 16%) 0px 16px 32px, rgb(0 0 0 / 16%) 0px 8px 16px, rgb(94 102 115 / 90%) 0px 0px 1px inset;
  background-color: ${props => props.theme.settingBg};
`

export const LSRow = styled.div`
  border-bottom: 1px solid ${props => props.theme.color}20;
  padding: 16px 0;
`

export const ColorBox = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 2px;
  background-color: ${props => props.color};
  margin: 0 4px;
`


export const LayoutSvgWrapper = styled.div`
  width: 88px;
  height: 56px;
  ${props => props.active && css`
    border: 1px solid ${props => props.theme.mainOrange};
  `};
  padding: 8px;
  background-color: #474d57;
  border-radius: 2px;
  position: relative;
`

export const LayoutSvgBody = styled.div`
  background-color: ${props => props.theme.secondaryBg};
  width: 100%;
  height: 100%;
  position: relative;
`

export const LayoutSvgDesc = styled.div`
  font-size: 11px;
  color: ${props => props.active ? props.theme.primary : props.theme.color};
  margin: 4px auto;
  
  ${props => props.hovered && css`
    color: ${props => props.theme.primary};
  `};
`


export const SvgBox = styled.div`
  position: absolute;
  left: ${props => props.left};
  bottom: ${props => props.bottom};
  background-color: ${props => props.theme.tInputBg};
`

export const SvgSpot = styled(SvgBox)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 26px;
  height: 12px;
  background-color: transparent;
`

export const SvgSpotItem = styled.div`
  background-color: ${props => props.type === 'buy' ? props.theme.mainGreen : props.theme.mainRed};
  width: 12px;
  height: 3px;
`

export const CustomSpotItem = styled(SvgSpotItem)`
  width: 18px;
  position: absolute;
  top: ${props => props.top};
  left: ${props => props.left};
`

export const SvgChart = styled(SvgBox)`
  height: 14px;
  width: 24px;
`

export const ToolboxWrapper = styled.div`
  width: 90%;
  transition: all 0.3s;
  border: 1px solid ${props => props.theme.color}20;
  border-radius: 2px;
  box-shadow: 0 0 4px rgb(0, 0, 0, 0.05);
  position: absolute;
  left: 5%;
  top: 80px;
  z-index: 20;
  background-color: ${props => props.theme.settingBg};
  padding: 9px 16px;
  min-height: 64px;
  transform: translateY(0);
  
  ${props => !props.open && css`
    transform: translateY(-58px);
  `};
`

export const ToolboxToggleWrapper = styled.div`
  transition: all 0.3s;
  height: 24px;
  width: 38px;
  background-color: ${props => props.theme.secondaryBg};
  position: absolute;
  bottom: ${props => props.open ? '-64px' : '-24px'};
  z-index: 18;
  left: calc(5% - 36px);
  border: 1px solid ${props => props.theme.color}20;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
`

export const ToolboxToggleIcon = styled(CgChevronDoubleDown)`
  color: ${props => props.theme.color};
  transition: all 0.3s;
  transform: rotate(0);

  ${props => props.open && css`
    transform: rotate(180deg);
  `};
`

export const ToolboxItemBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 4px;
  height: 100%;
  min-width: 140px;
  ${props => props.theme.english && css`
    border-right: 1px solid ${props => props.theme.color}20;
    padding-right: 8px;
  `};
  ${props => !props.theme.english && css`
    border-left: 1px solid ${props => props.theme.color}20;
    padding-left: 8px;
  `};
`


export const ToolboxBtn = styled.div`
  border-radius: 4px;
  border: 1px solid ${props => props.theme.color}90;
  color: ${props => props.theme.color};
  font-size: 0.8rem;
  width: 72px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  margin: 4px 8px;
  
  &:hover {
    color: black;
    background-color: ${props => props.theme.color};
    border: ${props => props.theme.mainBg};
  };

  ${props => props.submit && css`
    border: 1px solid ${props => props.theme.mainGreen}90;
    color: ${props => props.theme.mainGreen};
    
    &:hover {
      background-color: ${props => props.theme.mainGreen};
    };
  `};

  ${props => props.cancel && css`
    border: 1px solid ${props => props.theme.mainRed}90;
    color: ${props => props.theme.mainRed};

    &:hover {
      background-color: ${props => props.theme.mainRed};
    };
  `};
`

export const DraggableDashboardWrapper = styled.div`
  max-width: ${props => props.fullscreen ? '100%' : '1500px'};
  direction: ltr;
  margin: 64px auto 0 auto;
  ${props => props.border && css`
    border: 1px solid ${props => props.theme.color}20;
  `};
`

export const RefreshIcon = styled(IoMdRefresh)`
  color: ${props => props.theme.mainOrange};
  cursor: pointer;
`

export const LayoutSettingIconWrapper = styled.div`
  border-radius: 4px;
  padding: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  &:hover {
    background-color: ${props => props.theme.mainBg}80;
  };
`

export const EditIcon = styled(AiOutlineEdit)`
  color: ${props => props.theme.color};
`

export const DeleteIcon = styled(AiOutlineDelete)`
  color: ${props => props.theme.color};
`

export const LayoutItemBody = styled(Flex)`
  align-items: flex-start;
  margin-top: 4px;
  
  ${props => !props.theme.english && css`
    margin-left: ${props => props.custom ? '4px' : '28px'};
  `};
  ${props => props.theme.english && css`
    margin-right: ${props => props.custom ? '4px' : '28px'};
  `};
`

export const Draggable = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 120px;
  height: 48px;
  z-index: 10000;
  cursor: grab;
  
  &:active {
    cursor: grabbing;
  };
`

